export const PHONES = {
    CUSTOMER_CALL_CENTER: "0800 048 2446",
    ANNUITY_CUSTOMER_CALL_CENTER: "0800 326 5479",
};
